// extracted by mini-css-extract-plugin
module.exports = {"weMissedYouModal":"dQH7lo","textContainer":"_3lsAob","imageBox":"_1-p-Yb","messageBox":"ppcStm","bold":"_1yYqHC","contactInfo":"_1xRspi","birdImage":"_2OAQzi","button":"bZgSm9"};